import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
} from 'react'
import { getApiTargetInfo, rowHeaderRender, yesNoMap } from 'core'
import moment from 'moment'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'

import {
  getSolarEntity,
  getSolarPlant,
  getSolarScadaManufacturer,
  getSolarDCinputType,
  getSolarPanelTrackingType,
  getSolarOwnershipStatus,
  getSolarStorageManufacturer,
  getSolarStorageInverterManufacturer,
  updateSolarStorageGroup,
  getSolarStorageGroup,
  deleteSolarStorageGroup,
  getSolarStorageType,
  renameSolarStorageGroup,
  getSolarHistory,
} from 'api/pgads'

import { ErrorContext } from 'context'
import R from 'ramda'

import {
  Grid,
  toSelectionColProps,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import { modifierCol, SolarStorageGroupHeaders } from 'solar/Headers'
import {
  Button,
  DatePicker,
  Empty,
  Input,
  InputNumber,
  message,
  Modal,
  Popconfirm,
  Select,
  Spin,
  Tooltip,
} from 'antd'
import { modifiedDateCol } from 'core/HeaderColTypeProps'
import { strCol } from '@integec/grid-tools/lib/cols'
import { Content, FullHeightSizer } from 'core/screen-util'

const title = 'Solar Storage Group'

const getMap = (data, key, value) => {
  return R.compose(
    R.fromPairs,
    R.map(d => [d[key], d[value]])
  )(data)
}

const SolarStorageGroup = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [entityMap, setEntityMap] = useState({})
  const [plantMap, setPlantMap] = useState({})
  const [invManufacturerMap, setInvManufacturerMap] = useState({})
  const [manufacturerMap, setManufacturerMap] = useState({})
  const [scadaManufacturerMap, setScadafacturerMap] = useState({})
  const [dcInputTypeMap, setDCInputTypeMap] = useState({})
  const [panelTrackingTypeMap, setPanelTrackingTypeMap] = useState({})
  const [availableStatus, setAvailableStatus] = useState({})
  const [storageTypeMap, setStorageTypeMap] = useState({})
  const [showRenameModal, setShowRenameModal] = useState(false)
  const [showHistoryModal, setShowHistoryModal] = useState(false)

  const { setError } = useContext(ErrorContext)

  useEffect(
    _ => {
      getSolarEntity(apiTargetInfo).fork(setError, data => {
        const cd = R.compose(
          R.fromPairs,
          R.map(d => [d.entityId, d.entityId + ' - ' + d.entityName])
        )(data)
        // setEntityMap(getMap(data, 'entityId', 'entityName'))
        setEntityMap(cd)
      })
      getSolarPlant(apiTargetInfo).fork(
        _ => _,
        data => {
          setPlantMap(getMap(data, 'plantId', 'plantName'))
        }
      )
      getSolarStorageInverterManufacturer(apiTargetInfo).fork(
        _ => _,
        data => {
          setInvManufacturerMap(
            getMap(data, 'manufacturerCode', 'manufacturerName')
          )
        }
      )
      getSolarStorageManufacturer(apiTargetInfo).fork(
        _ => _,
        data => {
          setManufacturerMap(
            getMap(data, 'manufacturerCode', 'manufacturerName')
          )
        }
      )
      getSolarScadaManufacturer(apiTargetInfo).fork(
        _ => _,
        data => {
          setScadafacturerMap(
            getMap(data, 'manufacturerCode', 'manufacturerName')
          )
        }
      )
      getSolarDCinputType(apiTargetInfo).fork(
        _ => _,
        data => {
          setDCInputTypeMap(getMap(data, 'dcInputTypeCode', 'dcInputTypeName'))
        }
      )
      getSolarPanelTrackingType(apiTargetInfo).fork(
        _ => _,
        data => {
          setPanelTrackingTypeMap(
            getMap(data, 'trackingTypeCode', 'trackingTypeName')
          )
        }
      )
      getSolarOwnershipStatus(apiTargetInfo).fork(
        _ => _,
        data => {
          setAvailableStatus(
            getMap(data, 'ownershipStatusCode', 'ownershipStatusName')
          )
        }
      )
      getSolarStorageType(apiTargetInfo).fork(
        _ => _,
        data => {
          setStorageTypeMap(getMap(data, 'storageTypeCode', 'storageTypeName'))
        }
      )
    },
    [apiTargetInfo, setError]
  )

  const headerWithformater = useMemo(
    _ => {
      return SolarStorageGroupHeaders.map(header => {
        if (header.ident === 'entityId')
          return {
            ...header,
            dataFormatter: ({ value }) => entityMap[value] || value,
            sortIndexGetter: ({ rowData }) =>
              entityMap[rowData.entityId] || rowData.entityId,
          }

        if (header.ident === 'plantId')
          return {
            ...header,
            dataFormatter: ({ value }) =>
              plantMap[value] ? value + '-' + plantMap[value] : value,
            sortIndexGetter: ({ rowData }) =>
              plantMap[rowData.plantId] || rowData.plantId,
          }
        if (header.ident === 'storageInvManufacturer')
          return {
            ...header,
            ...toSelectionColProps(invManufacturerMap),
            dataFormatter: ({ value }) =>
              invManufacturerMap[value]
                ? value + '-' + invManufacturerMap[value]
                : value,
            sortIndexGetter: ({ rowData }) =>
              invManufacturerMap[rowData.storageInvManufacturer] ||
              rowData.storageInvManufacturer,
          }
        if (header.ident === 'storageManufacturer')
          return {
            ...header,
            ...toSelectionColProps(manufacturerMap),
            dataFormatter: ({ value }) =>
              manufacturerMap[value]
                ? value + '-' + manufacturerMap[value]
                : value,
            sortIndexGetter: ({ rowData }) =>
              manufacturerMap[rowData.storageManufacturer] ||
              rowData.storageManufacturer,
          }
        if (header.ident === 'scadaManufacturer')
          return {
            ...header,
            ...toSelectionColProps(scadaManufacturerMap),
            dataFormatter: ({ value }) =>
              scadaManufacturerMap[value]
                ? value + '-' + scadaManufacturerMap[value]
                : value,
            sortIndexGetter: ({ rowData }) =>
              scadaManufacturerMap[rowData.scadaManufacturer] ||
              rowData.scadaManufacturer,
          }

        if (header.ident === 'dcInputType')
          return {
            ...header,
            ...toSelectionColProps(dcInputTypeMap),
            dataFormatter: ({ value }) =>
              dcInputTypeMap[value]
                ? value + '-' + dcInputTypeMap[value]
                : value,
            sortIndexGetter: ({ rowData }) =>
              dcInputTypeMap[rowData.dcInputType] || rowData.dcInputType,
          }

        if (header.ident === 'panelTrackingType')
          return {
            ...header,
            ...toSelectionColProps(panelTrackingTypeMap),
            dataFormatter: ({ value }) =>
              panelTrackingTypeMap[value]
                ? value + '-' + panelTrackingTypeMap[value]
                : value,
            sortIndexGetter: ({ rowData }) =>
              panelTrackingTypeMap[rowData.panelTrackingType] ||
              rowData.panelTrackingType,
          }

        if (header.ident === 'storageOwnershipStatus')
          return {
            ...header,
            ...toSelectionColProps(availableStatus),
            dataFormatter: ({ value }) =>
              availableStatus[value]
                ? value + '-' + availableStatus[value]
                : value,
            sortIndexGetter: ({ rowData }) =>
              availableStatus[rowData.storageOwnershipStatus] ||
              rowData.storageOwnershipStatus,
          }
        if (header.ident === 'storageType')
          return {
            ...header,
            ...toSelectionColProps(storageTypeMap),
            dataFormatter: ({ value }) =>
              storageTypeMap[value]
                ? value + '-' + storageTypeMap[value]
                : value,
            sortIndexGetter: ({ rowData }) =>
              storageTypeMap[rowData.storageType] || rowData.storageType,
          }

        return header
      })
    },
    [
      storageTypeMap,
      invManufacturerMap,
      manufacturerMap,
      scadaManufacturerMap,
      dcInputTypeMap,
      panelTrackingTypeMap,
      availableStatus,
      entityMap,
      plantMap,
    ]
  )

  const InsertComp = useCallback(
    comProps => (
      <SolarInverterGroupUpdate
        {...comProps}
        entityMap={entityMap}
        plantMap={plantMap}
        invManufacturerMap={invManufacturerMap}
        scadaManufacturerMap={scadaManufacturerMap}
        dcInputTypeMap={dcInputTypeMap}
        panelTrackingTypeMap={panelTrackingTypeMap}
        availableStatus={availableStatus}
        manufacturerMap={manufacturerMap}
        storageTypeMap={storageTypeMap}
      />
    ),
    [
      entityMap,
      plantMap,
      invManufacturerMap,
      scadaManufacturerMap,
      dcInputTypeMap,
      panelTrackingTypeMap,
      availableStatus,
      manufacturerMap,
      storageTypeMap,
    ]
  )

  const sortOnData = data => {
    return data.map(d => ({
      ...d,
      effectiveDate:
        d.effectiveDate && moment(d.effectiveDate).format('MM/DD/YYYY'),
      commisionDate:
        d.commisionDate && moment(d.commisionDate).format('MM/DD/YYYY'),
    }))
  }

  const modifySaveDataBeforeSave = data => {
    return data.map(d => ({
      ...d,
      effectiveDate:
        d.effectiveDate && moment(d.effectiveDate).format('YYYY-MM-DD'),
      commisionDate:
        d.commisionDate && moment(d.commisionDate).format('YYYY-MM-DD'),
    }))
  }

  const extraCriteriaAfterButton = ({
    data,
    onRetrieve,
    apiTargetInfo,
    setSpinning,
  }) => {
    return (
      <div>
        {showRenameModal && (
          <RenameModal
            list={data.map(e => ({
              label: e.storageGroupId,
              value: e.storageGroupId + '-' + e.plantId,
            }))}
            modalFor="Storage Group"
            hide={() => setShowRenameModal(false)}
            onOk={data => {
              const { oldId, newId } = data
              const ids = oldId?.split('-')

              setSpinning(true)
              renameSolarStorageGroup(apiTargetInfo)({
                oldId: ids[0],
                plantId: ids[1],
                newId,
              }).fork(setError, _ => {
                setSpinning(false)
                onRetrieve()
              })
            }}
          />
        )}
        {showHistoryModal && (
          <HistoryModal
            dataName="STORAGE GROUP"
            apiTargetInfo={apiTargetInfo}
            setError={setError}
            hide={() => setShowHistoryModal(false)}
          />
        )}
        <Button
          onClick={() => setShowRenameModal(true)}
          type="primary"
          // style={{ marginLeft: '10px' }}
        >
          Rename Storage Group
        </Button>
        <Button
          onClick={() => setShowHistoryModal(true)}
          type="primary"
          style={{ marginLeft: '10px' }}
        >
          Show Rename History
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      sortOnData={sortOnData}
      modifySaveDataBeforeSave={modifySaveDataBeforeSave}
      title={title}
      header={headerWithformater}
      saveTask={updateSolarStorageGroup}
      retrieveTask={getSolarStorageGroup}
      deleteTask={deleteSolarStorageGroup}
      altBy={d => d.entityId}
      autoRetrieve
      showDatePickerOnEdit
      //   sortOptions={[
      //     strCol({
      //       ident: 'plantName',
      //       display: 'Plant Name',
      //       isKey: true,
      //       sortOrder: 'asc',
      //     }),
      //   ]}
      //   initialSortOptions={[
      //     strCol({
      //       ident: 'plantName',
      //       display: 'Plant Name',
      //       isKey: true,
      //       sortOrder: 'asc',
      //     }),
      //   ]}
      widthOffset={50}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      insertComp={insertEvent && InsertComp}
      insertCompHeight={200}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey={false}
      headerRowHeight={60}
      defaultInsertData={{
        daylightSaving: 'N',
        plantOwnershipStatus: 'AV',
        chargeableFromGrid: 'No',
        effectiveDateMod: moment(),
        effectiveDate: moment().format('YYYY-MM-DD'),
        commisionDateMod: moment(),
        commisionDate: moment().format('YYYY-MM-DD'),
      }}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SolarStorageGroup)

const SolarInverterGroupUpdate = ({
  setInsertData,
  insertData,
  onAdd,
  onCancel,
  entityMap = {},
  plantMap = {},
  invManufacturerMap = {},
  availableStatus = {},
  manufacturerMap = {},
  storageTypeMap = {},
}) => {
  const getLabel = useCallback((key, isKey, isRequired) => {
    const header = (SolarStorageGroupHeaders || []).find(f => f.ident === key)

    let isFieldRequired = false

    if (header && (header.isKey || header.isRequired)) {
      isFieldRequired = true
    } else if (isRequired || isKey) {
      isFieldRequired = true
    }

    return (
      <div>
        {isFieldRequired && (
          <span style={{ color: 'red', marginRight: '2px' }}>*</span>
        )}
        {header && header.display}:
      </div>
    )
  }, [])

  const getInput = useCallback(
    ({
      key,
      maxLength,
      isKey,
      insertData,
      setInsertData,
      isRequired = false,
    }) => (
      <div>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <Input
          disabled={insertData.insert && isKey}
          value={insertData[key]}
          data-cy={key}
          onChange={e =>
            setInsertData({ ...insertData, [key]: e.target.value })
          }
          maxLength={maxLength}
        />
      </div>
    ),
    [getLabel]
  )
  const getMapSelect = useCallback(
    ({
      key,
      keymap,
      isKey,
      setInsertData,
      insertData,
      isRequired = false,
      extStyle = {},
    }) => (
      <div style={{ ...extStyle }}>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <Select
          showSearch
          disabled={insertData.insert && isKey}
          data-cy={key}
          style={{ width: '100%', zIndex: 500 }}
          value={insertData[key]}
          onChange={val => setInsertData({ ...insertData, [key]: val })}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {Object.keys(keymap).map(k => (
            <Select.Option value={k} key={k} data-cy={key}>
              {/* {`${k}-${keymap[k]}`} */}
              {`${keymap[k]}`}
            </Select.Option>
          ))}
        </Select>
      </div>
    ),
    [getLabel]
  )

  const getInputNumber = useCallback(
    ({
      key,
      precision = 0,
      isKey = false,
      insertData,
      setInsertData,
      isRequired = false,
      min,
      max,
    }) => (
      <div>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <Tooltip
          placement="top"
          title={
            (min || max) &&
            (min ? 'Min ' + min + ', ' : ' ') + (max ? 'Max ' + max : '')
          }
        >
          <InputNumber
            disabled={insertData.insert && isKey}
            style={{ width: '100%' }}
            value={insertData[key]}
            data-cy={key}
            onChange={value =>
              setInsertData({ ...insertData, [key]: value + '' })
            }
            precision={precision}
            min={min}
            max={max}
          />
        </Tooltip>
      </div>
    ),
    [getLabel]
  )
  const getDate = useCallback(
    ({ key, insertData, isKey, setInsertData, isRequired = false }) => (
      <div>
        {getLabel(key, isKey, isRequired)}
        <DatePicker
          style={{ width: '100%' }}
          format="MM/DD/YYYY"
          value={insertData[key + 'date']}
          data-cy={key}
          onChange={d => {
            setInsertData({
              ...insertData,
              [key]: d.format('YYYY-MM-DD'),
              [key + 'date']: d,
            })
          }}
        />
      </div>
    ),
    [getLabel]
  )

  return (
    <div
      style={{
        display: 'grid',
        // gridTemplateColumns: '250px 250px 250px 270px 210px 210px 210px',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridTemplateRows: '60px 60px 60px',
        gridColumnGap: '10px',
        gridRowGap: '7px',
      }}
    >
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'entityId',
        isKey: true,
        keymap: entityMap,
      })}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'plantId',
        isKey: true,
        keymap: plantMap,
      })}
      {getInput({
        setInsertData,
        insertData,
        key: 'storageGroupId',
        isKey: true,
      })}
      {getInput({
        setInsertData,
        insertData,
        key: 'storageGroupName',
        isKey: true,
      })}
      {getInput({
        setInsertData,
        insertData,
        key: 'storageGroupEiaCode',
        isKey: true,
      })}
      {getInput({
        setInsertData,
        insertData,
        key: 'storageIsoResourceId',
        // isKey: true,
      })}
      {getDate({
        setInsertData,
        insertData,
        key: 'commisionDate',
        maxLength: 10,
      })}
      {getDate({
        setInsertData,
        insertData,
        key: 'effectiveDate',
        maxLength: 10,
        isRequired: true,
      })}

      {getMapSelect({
        setInsertData,
        insertData,
        key: 'storageOwnershipStatus',
        keymap: availableStatus,
        isRequired: true,
      })}
      {getInputNumber({
        setInsertData,
        insertData,
        key: 'nameplateCapacity',
        isRequired: true,
        precision: 2,
      })}
      {getInputNumber({
        setInsertData,
        insertData,
        key: 'nameplateEnergy',
        isRequired: true,
        precision: 2,
      })}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'connectionType',
        // keymap: dcInputTypeMap,
        isRequired: true,
        keymap: { AC: 'AC', DC: 'DC' },
      })}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'chargeableFromGrid',
        keymap: yesNoMap,
      })}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'storageType',
        keymap: storageTypeMap,
        isRequired: true,
      })}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'storageInvManufacturer',
        keymap: invManufacturerMap,
        isRequired: true,
      })}

      {getInput({
        setInsertData,
        insertData,
        key: 'storageInvModel',
        isRequired: true,
      })}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'storageManufacturer',
        keymap: manufacturerMap,
        isRequired: true,
      })}
      {getInput({
        setInsertData,
        insertData,
        key: 'storageModel',
        isRequired: true,
      })}
      {getInput({
        setInsertData,
        insertData,
        key: 'transferToEntityId',
        maxLength: 10,
      })}
      <div
        style={{
          gridColumnEnd: 'span 2',
          display: 'grid',
          gridTemplateColumns: 'min-content max-content min-content',
          gap: 10,
          // paddingBottom: '7px',
          alignContent: 'end',
        }}
      >
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  )
}

export const RenameModal = ({ modalFor, list, hide, onOk }) => {
  const [oldId, setOldId] = useState()
  const [newId, setNewId] = useState('')

  return (
    <Modal
      maskClosable
      title={'Rename ' + modalFor}
      visible
      onCancel={() => hide()}
      footer={[
        <Button key="back" type="primary" onClick={() => hide()}>
          Close
        </Button>,
        <Popconfirm
          key="submit"
          title={
            'This will change the old ' +
            modalFor +
            ' "' +
            oldId +
            '" to new "' +
            newId +
            '". Are you sure to continue?'
          }
          okText="Yes"
          cancelText="No"
          onConfirm={() => {
            hide()
            onOk({ oldId, newId })
          }}
          placement="bottomRight"
          disabled={!oldId || !newId}
        >
          <Button
            type="primary"
            onClick={() => {
              if (!oldId || !newId) {
                message.info(
                  !oldId
                    ? 'Please, Select Old ' + modalFor + ' ID to Rename'
                    : 'Please, Enter New ' + modalFor + ' ID to Save'
                )
              }
            }}
          >
            Ok
          </Button>
        </Popconfirm>,
      ]}
      destroyOnClose
      closable
    >
      <div>
        <Select
          style={{ width: '200px', marginRight: '10px' }}
          placeholder={'Old ' + modalFor + ' ID'}
          value={oldId}
          onChange={c => setOldId(c)}
        >
          {list.map(s => (
            <Select.Option key={s.value} value={s.value}>
              {s.label}
            </Select.Option>
          ))}
        </Select>
        =
        <Input
          style={{
            gridColumnEnd: 'span 3',
            marginLeft: '10px',
            width: '200px',
          }}
          placeholder={'New ' + modalFor + ' ID'}
          value={newId}
          onChange={e => setNewId(e.target.value)}
        />
      </div>
    </Modal>
  )
}

export const HistoryModal = ({ dataName, apiTargetInfo, hide, setError }) => {
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    getSolarHistory(apiTargetInfo)({ dataName }).fork(setError, data => {
      setHistory(data)
      setLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal
      maskClosable
      title="Rename History"
      width="70vw"
      visible
      footer={null}
      onCancel={() => hide()}
      destroyOnClose
      closable
    >
      <Spin spinning={loading}>
        <FullHeightSizer heightOffset={300}>
          {({ height, width }) =>
            history.length > 0 ? (
              <Grid
                sortEnabled
                data={history}
                headers={historyHeaders}
                altBy={u => u.oldId}
                altBgColor="#ebebeb"
                render={virtualizedGridRenderer({
                  rowHeaderRender,
                  height,
                  width,
                })}
                isEditable={false}
                initialSortOptions={historyHeaders}
              />
            ) : (
              <Content style={{ height: '200px' }}>
                <Empty imageStyle={{ paddingTop: '30px' }} />
              </Content>
            )
          }
        </FullHeightSizer>
      </Spin>
    </Modal>
  )
}

const historyHeaders = [
  strCol({
    ident: 'dataName',
    display: 'Data Name',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'oldId',
    display: 'Old ID',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'newId',
    display: 'New ID',
    isFiltered: true,
    width: 200,
  }),
  modifierCol,
  modifiedDateCol,
]
